import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { useAuth } from '../auth'
import { IntegrationsPage } from '../integrations/components/integrations-page'
import { useTitle } from '../hooks/use-title'
import { useTranslation } from 'react-i18next'
import { NotSubscribedResult } from '../components/not-subscribed-result'
import { z } from 'zod'
import { searchQuery } from '../zod/pagination'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/integrations')({
    validateSearch: searchQuery.and(
        z.object({
            connection: z.string().optional(),
            state: z.string().optional(),
            view: z.enum(['tokens', 'webhooks']).optional(),
        })
    ),
    component: Integrations,
})

function Integrations() {
    const { hasSubscription } = useAuth()

    const { t } = useTranslation()
    const { view, ...query } = Route.useSearch()

    useTitle(t('Integrations'))

    if (!hasSubscription) {
        return (
            <>
                <NotSubscribedResult />
            </>
        )
    }

    return (
        <>
            <PageTitle
                title={t('Integrations')}
                subtitle={t('Connect tools like Facebook and Zapier to bring leads into Evaa.')}
            />
            <IntegrationsPage
                view={view}
                query={query}
            />
        </>
    )
}
